import { Report } from "interfaces";
import { ModalResolveReportPartiallyWrongBodyLeft } from "./ModalResolveReportPartiallyWrongBodyLeft";
import { ModalResolveReportPartiallyWrongBodyRight } from "./ModalResolveReportPartiallyWrongBodyRight";

export const ModalResolveReportPartiallyWrongBody = ({
  report,
  onClose,
}: {
  report: Report;
  onClose: Function;
}) => {
  return (
    <div className="d-grid grid-column-300 modal-resolve-source-body">
      <ModalResolveReportPartiallyWrongBodyLeft report={report} />
      <ModalResolveReportPartiallyWrongBodyRight
        report={report}
        onClose={onClose}
      />
    </div>
  );
};
